"use strict";
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/not.js
// module id = 752
// module chunks = 3